import React, { useEffect } from 'react';
import { EventsJson } from '../data/EventsJson';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { GiClick } from 'react-icons/gi';

const Index = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  // Get the first event
  const event = EventsJson[0]; 

  return (
    <div className="relative bg-gradient-to-br from-[#0f2027] via-[#203a43] to-[#2c5364] w-full py-16 overflow-hidden">
      
      {/* Decorative Background Blobs */}
      <div className="absolute -top-32 -left-32 w-96 h-96 bg-purple-700/40 rounded-full mix-blend-overlay blur-3xl animate-pulse"></div>
      <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-indigo-600/40 rounded-full mix-blend-overlay blur-3xl animate-ping"></div>

      {/* Main Container */}
      <div 
        id="Events" 
        className="relative z-10 w-full md:w-10/12 lg:w-8/12 mx-auto bg-white/90 backdrop-blur-xl shadow-2xl rounded-3xl p-10 border border-gray-300"
      >
        {/* Heading */}
        <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-purple-500 to-indigo-600 drop-shadow-lg tracking-wide">
          Technical Events & Culturals
        </h2>

        {/* Intro Text */}
        <p className="text-lg text-center mb-12 mx-auto max-w-3xl text-gray-700 leading-relaxed">
          Our <span className="font-bold text-indigo-600">Yantra 2K25 </span> 
           brings you a spectrum of <span className="text-purple-600 font-semibold">technical challenges </span> 
           and <span className="text-pink-600 font-semibold">cultural programs </span> 
           designed to inspire creativity, teamwork, and celebration.
        </p>

        {/* Event Card */}
        <div className="flex justify-center w-full">
          <div
            data-aos="fade-up"
            data-aos-duration="900"
            className="bg-gradient-to-tr from-indigo-50 via-white to-indigo-100 shadow-xl rounded-2xl overflow-hidden flex flex-col transition-transform transform hover:scale-105 hover:shadow-indigo-400/50 duration-500"
          >
            {/* Event Image */}
            <img
              src={event.imgSrc}
              alt={event.title[0]}
              className="w-full h-64 object-cover rounded-t-2xl"
            />

            {/* Content */}
            <div className="flex-1 p-6 flex flex-col justify-between">
              <div className="text-center">
                <h3 className="text-2xl font-bold mb-4 bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-md rounded-md py-2 uppercase tracking-wide">
                  Participation Fees
                </h3>

                {/* Event List */}
                <ul className="list-disc text-left mx-6 text-lg text-gray-800 space-y-2">
                  {event.title.map((title, index) => (
                    <li key={index}>
                      <span className="font-semibold text-indigo-700">{title}</span> — 
                      <span className="ml-2">{event.price[index].amount} {event.price[index].currency}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Register Button */}
              <div className="flex justify-center mt-8">
                <a 
                  className="min-w-[60%] text-center px-5 py-3 rounded-full text-lg font-bold 
                             bg-gradient-to-r from-pink-500 via-red-500 to-yellow-400 
                             text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-500 flex items-center justify-center gap-2"
                  href="https://forms.gle/88Lzre56nVhUmzau8" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <GiClick className="text-xl" />
                  Register Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
